export default [
  'mdiCircle',
  'mdiCircleDouble',
  'mdiCircleOutline',
  'mdiCube',
  'mdiCubeOutline',
  'mdiDecagram',
  'mdiDecagramOutline',
  'mdiDrawing',
  'mdiDrawingBox',
  'mdiEllipse',
  'mdiEllipseOutline',
  'mdiHeart',
  'mdiHeartOutline',
  'mdiHeartMultiple',
  'mdiHeartMultipleOutline',
  'mdiHexagon',
  'mdiHexagonMultiple',
  'mdiHexagonOutline',
  'mdiHexagram',
  'mdiHexagramOutline',
  'mdiOctagon',
  'mdiOctagonOutline',
  'mdiOctagram',
  'mdiOctagramOutline',
  'mdiPentagon',
  'mdiPentagonOutline',
  'mdiRectangle',
  'mdiRectangleOutline',
  'mdiRhombus',
  'mdiRhombusMedium',
  'mdiRhombusMediumOutline',
  'mdiRhombusOutline',
  'mdiRhombusSplit',
  'mdiRhombusSplitOutline',
  'mdiShape',
  'mdiShapeCirclePlus',
  'mdiShapeOutline',
  'mdiShapePlus',
  'mdiShapePolygonPlus',
  'mdiShapeRectanglePlus',
  'mdiShapeSquarePlus',
  'mdiSquare',
  'mdiSquareMedium',
  'mdiSquareMediumOutline',
  'mdiSquareOutline',
  'mdiStar',
  'mdiStarCheck',
  'mdiStarCheckOutline',
  'mdiStarFourPoints',
  'mdiStarFourPointsOutline',
  'mdiStarHalf',
  'mdiStarMinus',
  'mdiStarMinusOutline',
  'mdiStarOutline',
  'mdiStarPlus',
  'mdiStarPlusOutline',
  'mdiStarRemove',
  'mdiStarRemoveOutline',
  'mdiStarThreePoints',
  'mdiStarThreePointsOutline',
  'mdiTriangle',
  'mdiTriangleOutline',
  'mdiSquareRounded',
  'mdiSquareRoundedOutline',
  'mdiCropSquare',
  'mdiDotsSquare',
];
